package com.parmartechnologies.core.feature.invoice.model

import com.parmartechnologies.core.extension.BaseDataClass
import com.parmartechnologies.core.extension.UniqueueID
import com.parmartechnologies.core.feature.sale.model.Sale
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class CustomerInvoice @OptIn(ExperimentalTime::class) constructor(
    @SerialName("invoice_id") var InvoiceId: Long = Clock.System.now().epochSeconds,
    @SerialName("share_link") var ShareLink: String = "",
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("customer_id") var customerID: String = "",
    @SerialName("customer_name") var customerName: String = "",
    @SerialName("dial_code") var DialCode: String = "",
    @SerialName("mobile_number") var MobileNumber: String = "",
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    @SerialName("sales") var Sales: List<Sale>? = arrayListOf(),
    @SerialName("invoice_number") var InvoiceNumber: Long = 0,
    @SerialName("invoice_type") var invoiceType: String = "",
    @SerialName("total_price") var totalPrice: Double = 0.0,
    @SerialName("gst") var GST: Double = 0.0,
    @SerialName("sgst") var SGST: Double = 0.0,
    @SerialName("cgst") var CGST: Double = 0.0,
    @SerialName("igst") var IGST: Double = 0.0,
    @SerialName("cess") var CESS: Double = 0.0,
    @SerialName("vat") var VAT: Double = 0.0,
    @SerialName("tax") var Tax: Double = 0.0,
    @SerialName("cost_price") var costPrice: Double = 0.0,
    @SerialName("instant_discount") var instantDiscount: Double = 0.0,
    @SerialName("final_price") var finalPrice: Double = 0.0,
    @SerialName("pending_amount") var pendingAmount: Double = 0.0,
    @SerialName("cleared_amount") var clearedAmount: Double = 0.0,
    @SerialName("invoice_date") var invoiceDate: String = "",
): BaseDataClass()
